export const getPhotoUrl = (baseAddress: string, url: string): string =>
  `${baseAddress}${url}`;
